module.exports = __webpack_public_path__ + "static/media/Monday_Step3_Image20.8d22e03f.webp";